import React from 'react';
import { BsDot } from 'react-icons/bs';
import GalleryOne from '../../img/latest/gallery/img-1.jpg';
import GalleryTwo from '../../img/latest/gallery/img-2.jpg';
import GalleryThree from '../../img/latest/gallery/img-3.jpg';
import GalleryFour from '../../img/latest/gallery/img-4.jpg';
import GalleryFive from '../../img/latest/gallery/img-5.jpg';
import GallerySix from '../../img/latest/gallery/img-6.jpg';
import HappyImg1 from '../../img/latest/img-1.png';
import HappyImg2 from '../../img/latest/img-2.png';
import LatestBg from '../../img/latest/latest-bg.png';

const Latest = () => {
    return (
        <div className='main text-center  bg-no-repeat bg-right-top py-16' style={{ fontFamily: "Merienda", backgroundImage: 'url(' + LatestBg + ')' }} >
            <div className='md:flex justify-center '>
                <div className='lg:mr-16 md:mr-8 md:w-2/3 w-full' >
                    <h1 className='section-title text-center' >Latest Update </h1>
                    <div className='flex justify-center items-center
                    '>
                        <div className='border border-[#CCCCCC] border-1 w-[80px]'></div>
                        <BsDot className='text-2xl' />
                        <div className='border border-[#CCCCCC] border-1 w-[80px]'></div>
                    </div>
                    {/* top  */}
                    <div className='md:flex justify-between items-center py-8'>
                        <div className='w-3/4'>
                            <img className='md:w-1/2 lg:mx-auto' src={HappyImg1} alt="" />
                        </div>
                        <div className='lg:w-2/4 md:w-3/4'>
                            <h4 className='tiny-title'>Happy Hour, between 4pm & 5pm</h4>
                            <p className='pragraph text-start '>In specialty coffee culture an ability to properly brew coffee is summing it all up. In one cup of coffee we bring together efforts of all of those who worked o...</p>
                        </div>
                    </div>
                    <hr />
                    {/* bottom  */}
                    <div className='md:flex justify-between items-center py-8'>
                        <div className='lg:w-2/4 md:w-3/4'>
                            <h4 className='tiny-title'>Brew coffee is summing it all up</h4>
                            <p className='pragraph  text-start'>In specialty coffee culture an ability to properly brew coffee is summing it all up. In one cup of coffee we bring together efforts of all of those who worked o...</p>
                        </div>
                        <div className='w-3/4'>
                            <img className='md:w-1/2 mx-auto' src={HappyImg2} alt="" />
                        </div>
                    </div>
                    <hr />
                </div>
                <div className='md:w-1/3 '>
                    <div className='grid grid-cols-2 border border-8 border-[#E6D7C7]'>
                        <img className=' w-full hover:bg-black' src={GalleryOne} alt="" />
                        <a href="#"><img className=' w-full ' src={GalleryTwo} alt="" /></a>
                        <a href="#"> <img className=' w-full ' src={GalleryThree} alt="" /></a>
                        <a href="#"><img className=' w-full ' src={GalleryFour} alt="" /></a>
                        <a href="#"><img className=' w-full ' src={GalleryFive} alt="" /></a>
                        <a href="#"> <img className=' w-full ' src={GallerySix} alt="" /></a>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default Latest;